import React from 'react';
import PropTypes from 'prop-types';
import PostList from './postlist';

const LatestPosts = ({ tag: Tag, className, posts, postsPerPage: paginationPageSize, ...rest }) => (
  <Tag className={className}>
    {posts && posts.length ? (
      <PostList posts={posts} paginationPageSize={paginationPageSize} {...rest} />
    ) : (
      <strong>No Posts Available</strong>
    )}
  </Tag>
);

LatestPosts.defaultProps = {
  tag: 'section',
};

LatestPosts.propTypes = {
  tag: PropTypes.string,
};

export default LatestPosts;
